<template>
  <div style="position: relative" @mousewheel="mouseWheel">
    <slot></slot>
    <div :class="{ background: title }" v-if="showOverlay">
      <span class="hvh-h3" style="color: white" v-if="title">
        {{ title }}
      </span>
    </div>
  </div>
</template>

<script>
import { Debouncer, getAllChildrens } from '../../../libraries/common';
import '../../../libraries/extensions/listeners';

export default {
  props: ['title', 'notVisible'],
  data() {
    return {
      showOverlay: false,
      debounce: new Debouncer(1000),
    };
  },
  methods: {
    mouseWheel(event) {
      if (this.showOverlay && event.ctrlKey) event.preventDefault();
      this.showOverlay = !event.ctrlKey;

      this.debounce.clear();
      if (this.showOverlay) {
        this.debounce.push(() => this.showOverlay = false);
      }
    },
    replaceEvents() {
      if (this.$el) {
        getAllChildrens(this.$el)
          .filter(el => el.listeners)
          .forEach(el => {
            ['wheel', 'mousewheel'].forEach(prop => {
              (el.listeners[prop] || [])
                .filter(fnc => !fnc.myEvent)
                .forEach(fnc => {
                  el.removeEventListener(prop, fnc);
                  var newEvent = event => {
                    if (event.ctrlKey) {
                      fnc(event);
                    }
                  };
                  newEvent.myEvent = true;
                  el.addEventListener(prop, newEvent);
                });
            });
          });
      }
    }
  },
  mounted() {
    this.replaceEvents();
  },
  updated() {
    this.replaceEvents();
  }
};
</script>

<style scoped>
.background {
  background-color: rgb(0, 0, 0, 0.5);
  color: white;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
</style>